export default __webpack_public_path__ + "static/media/energyInActiveIcon.94f3b162.svg";